import React from 'react';

interface TabNavigationProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const TabNavigation: React.FC<TabNavigationProps> = ({ activeTab, onTabChange }) => {
  const tabs = [
    {
      id: 'dashboard',
      label: 'ダッシュボード',
      icon: '📊', // Font Awesome would be fas fa-chart-pie
      iconFallback: 'fas fa-chart-pie'
    },
    {
      id: 'tasks',
      label: 'タスク一覧',
      icon: '📋', // Font Awesome would be fas fa-tasks  
      iconFallback: 'fas fa-tasks'
    },
    {
      id: 'add-task',
      label: 'タスク追加',
      icon: '➕', // Font Awesome would be fas fa-plus-circle
      iconFallback: 'fas fa-plus-circle'
    },
    {
      id: 'settings',
      label: '設定',
      icon: '⚙️', // Font Awesome would be fas fa-cog
      iconFallback: 'fas fa-cog'
    }
  ];

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      backgroundColor: 'white',
      borderTop: `1px solid var(--color-neutral-200)`,
      display: 'flex',
      justifyContent: 'space-around',
      padding: 'var(--spacing-2) 0',
      boxShadow: '0 -2px 5px rgba(0,0,0,0.05)'
    }} className="md:hidden">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: 'var(--spacing-1) var(--spacing-2)',
            fontSize: 'var(--font-size-xs)',
            color: activeTab === tab.id ? 'var(--color-primary-500)' : 'var(--color-neutral-500)',
            transition: 'color var(--transition-fast)',
            flexGrow: 1,
            border: 'none',
            background: 'transparent',
            cursor: 'pointer',
            fontWeight: activeTab === tab.id ? 'var(--font-weight-semibold)' : 'var(--font-weight-normal)',
            fontFamily: 'var(--font-family-sans)',
            outline: 'none'
          }}
          className={activeTab === tab.id ? 'tab-button-active' : 'tab-button'}
        >
          <div style={{
            fontSize: '1.25rem',
            marginBottom: 'var(--spacing-1)',
            transition: 'transform var(--transition-fast)',
            transform: activeTab === tab.id ? 'scale(1.1)' : 'scale(1)'
          }}>
            {tab.icon}
          </div>
          <span>{tab.label}</span>
        </button>
      ))}
      
      <style>{`
        /* タブボタンホバー効果 */
        .tab-button:hover {
          color: var(--color-primary-400) !important;
        }
        
        .tab-button-active:hover {
          color: var(--color-primary-600) !important;
        }
        
        /* レスポンシブ調整 */
        @media (min-width: 768px) {
          .tab-navigation {
            display: none;
          }
        }
        
        /* 安全なタップエリア */
        .tab-button {
          min-height: 48px;
          -webkit-tap-highlight-color: transparent;
        }
        
        /* フォーカス可視性 */
        .tab-button:focus-visible {
          outline: 2px solid var(--color-primary-500);
          outline-offset: 2px;
          border-radius: var(--radius-base);
        }
      `}</style>
    </div>
  );
};

export default TabNavigation; 